"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const lodash_1 = require("lodash");
const constants_1 = require("../constants");
const api_1 = require("../api");
const LoadingSpinner_1 = require("../shared/LoadingSpinner");
class SocialLinksComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            state: constants_1.ProgressState.Loading,
            businessId: '',
            business: null
        };
    }
    componentWillMount() {
        api_1.doGet(api_1.API.v1.BUSINESSES.GET_PUBLIC(this.props.params.businessId)).then(response => {
            this.setState({
                business: response.data.business,
                state: constants_1.ProgressState.Success
            });
        }).catch(error => {
            this.setState({
                state: constants_1.ProgressState.Failed
            });
        });
    }
    render() {
        let content;
        switch (this.state.state) {
            case constants_1.ProgressState.Loading:
                content = React.createElement(LoadingSpinner_1.default, { key: "ReplyLoadingSpinner" });
                break;
            case constants_1.ProgressState.Success:
                content = this.renderSocialInfo();
                break;
            case constants_1.ProgressState.None:
                lodash_1.delay(() => this.setState({ state: constants_1.ProgressState.Success }), 10);
                break;
            default:
                break;
        }
        return React.createElement("div", null, content);
    }
    componentDidUpdate() {
        $('[data-toggle="popover"]').popover({
            trigger: 'focus'
        });
    }
    renderSocialInfo() {
        return React.createElement("div", null, React.createElement("div", { className: "socialLinks_main" }, React.createElement("div", { className: "socialLinks_businessName" }, "Business: ", this.state.business.name), this.state.business.socialMediaConfig.googleReviewLink && this.state.business.socialMediaConfig.googleReviewLink && React.createElement("div", { className: "socialLinks_row" }, React.createElement("p", { className: "socialLinks_title" }, "Google review"), React.createElement("p", { className: "socialLinks_link" }, React.createElement("a", { href: this.state.business.socialMediaConfig.googleReviewLink, target: "_blank" }, this.state.business.socialMediaConfig.googleReviewLink))), this.state.business.socialMediaConfig && this.state.business.socialMediaConfig.facebookPageLink && React.createElement("div", { className: "socialLinks_row" }, React.createElement("p", { className: "socialLinks_title" }, "Facebook page"), React.createElement("p", { className: "socialLinks_link" }, React.createElement("a", { href: this.state.business.socialMediaConfig.facebookPageLink, target: "_blank" }, this.state.business.socialMediaConfig.facebookPageLink)))), React.createElement("p", { className: "s_powered_by" }, React.createElement("a", { href: "/en", target: "_blank" }, "Powered by LoyalReach")));
    }
}
exports.default = SocialLinksComponent;


//////////////////
// WEBPACK FOOTER
// ./client/src/layout/SocialLinksComponent.tsx
// module id = 1358
// module chunks = 1 2